<script setup lang="ts">
/** Wordmark rosa (#FA3D8B) — identidade Bagy em login, sidebar e demais superfícies. */
const logoSrc = '/bagy-logo-dark.svg'
</script>

<template>
  <img
    :src="logoSrc"
    alt="Bagy Logo"
    class="bagy-logo"
  >
</template>

<style scoped>
.bagy-logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: left center;
  transition: opacity 0.3s ease;
}
</style>
